module.exports = __webpack_public_path__ + "img/wechattu2.1ec202cb.png";